import React from "react";
import { CourseScheduleApi } from "api";
import { PaziaButton } from "components/atoms";
import { formatDate } from "utils";
import { COURSE_PLACE_TYPE_OPTIONS } from "consts/courseScheduleType";

interface ExamScheduleReadOnlyPreviewProps {
  schedule: CourseScheduleApi;
  onNavigateToExams: () => void;
}

export const ExamScheduleReadOnlyPreview = ({
  schedule,
  onNavigateToExams,
}: ExamScheduleReadOnlyPreviewProps): JSX.Element => {
  const placeLabel = COURSE_PLACE_TYPE_OPTIONS.find((x) => x.value === schedule.placeType)?.label;

  return (
    <div className="flex flex-col gap-4 p-2">
      <div>
        <p className="text-lg font-semibold">{schedule.examName}</p>
        <p className="text-sm text-slate-500">
          {formatDate(schedule.dateFrom)}, {schedule.timeFrom}-{schedule.timeTo}
        </p>
        <p className="text-sm text-slate-500">Zjazd: {schedule.session?.name}</p>
        <p className="text-sm text-slate-500">
          Miejsce: {placeLabel}
          {schedule.placeName ? ` · ${schedule.placeName}` : ""}
        </p>
      </div>
      <p className="text-sm text-slate-500">
        Egzaminy edytujesz w zakładce Egzaminy — termin i miejsce widoczne tutaj to tylko podgląd.
      </p>
      <div className="flex justify-end">
        <PaziaButton type="primary" title="Przejdź do zakładki Egzaminy" onClick={onNavigateToExams} />
      </div>
    </div>
  );
};
